export class disputeStatus {
   
    id: number;
    status:string;
    updatedstatus:string;
    }